<template>
  <div id="daskcontrol-component">
    <div class="logo">
      <div class="logo-img"></div>
    </div>
    <div class="w-100 d-flex justify-content-center">
      <div class="wrapper">
        <div class="welcome">
          <span class="welcome-label">Bem-vindo(a) ao {{ testName }}</span>
        </div>
        <div class="instruction">
          <p>
            Aponte a câmera do seu celular ou tablet para o QR Code abaixo e
            siga as orientações para fazer seu teste e emitir seu cartão de
            resultado.
          </p>
        </div>
        <div class="background-qr-code">
          <div class="qr-code">
            <div class="qr-code-image"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="created-by">
      <div class="powered">
        Powered by 
      </div>
      <div class="img-clinicarx">
        <img :src="logoPath" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "DaskControl.scss";
</style>

<script>
import DaskControlComponent from "@/views/Shared/DaskControl/DaskControlComponent";
export default DaskControlComponent;
</script>
